import { useMsal } from '@azure/msal-react';
import { clearMsalStorage } from '@shared/helpers/msal-instance/msalInstance.utils';
import { getNavigationBlockSnapshot } from '@shared/hooks/use-navigation-block/navigationBlockStore';
import * as React from 'react';

/**
 * Custom hook that provides a logout function.
 * Clears session storage and redirects to the landing page.
 * Blocks logout when an in-flight operation is active (e.g. org import).
 *
 * @returns A memoized logout callback function
 */
export function useLogout(): () => void {
  const { instance } = useMsal();

  return React.useCallback((): void => {
    if (getNavigationBlockSnapshot()) {
      const shouldLeave = globalThis.confirm(
        'An operation is in progress. Are you sure you want to log out?'
      );
      if (!shouldLeave) return;
    }

    sessionStorage.clear();
    clearMsalStorage();
    instance.logoutRedirect({
      postLogoutRedirectUri: '/',
    });
  }, [instance]);
}
